import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";

const Perdayrecord = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const getRecords = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        "https://api.krludo.in/global-report",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRecords(res?.data?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRecords();
  }, []);

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow">
        <div className="card-header">
          <h4 className="mb-0">Per Day Report</h4>
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center">Loading...</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Date</th>
                    <th>Total Games</th>
                    <th>Success</th>
                    <th>Cancel</th>
                    <th>Game Amount</th>
                    <th>Admin Commission</th>
                    <th>Referral Commission</th>
                    <th>Deposit</th>
                    <th>Withdraw</th>
                    <th>Bonus</th>
                    <th>Penalty</th>
                  </tr>
                </thead>

                <tbody>
                  {records?.length > 0 ? (
                    records.map((item) => (
                      <tr key={item._id}>
                        <td>
                          {dayjs(item.createdAt).format(
                            "DD-MM-YYYY"
                          )}
                        </td>

                        <td>{item.totalgames}</td>
                        <td>{item.games_success}</td>
                        <td>{item.games_cancel}</td>
                        <td>₹{item.games_total_amount}</td>
                        <td>₹{item.admin_commision}</td>
                        <td>₹{item.refer_commision}</td>
                        <td>₹{item.totaldepositamount}</td>
                        <td>₹{item.totalwithdrawamount}</td>
                        <td>₹{item.totalbonusAmount}</td>
                        <td>₹{item.totalpeneltyAmount}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Perdayrecord;